import type { CmsPage } from "../../../../types/cms";
import { movedPath, sectionPath } from "../../pageAddress";
import type { PageSection } from "../../pageSection";
import styles from "./PageAddressFields.module.css";

type ChildPagesMoveWarningProps = {
  childPages: CmsPage[];
  oldSection: PageSection;
  newSection: PageSection;
  oldPath: string;
  newPath: string;
};

export function ChildPagesMoveWarning({
  childPages,
  oldSection,
  newSection,
  oldPath,
  newPath,
}: ChildPagesMoveWarningProps) {
  const example = childPages[0];
  if (!example || (oldSection === newSection && oldPath === newPath)) {
    return null;
  }

  const count = childPages.length;
  const summary =
    count === 1
      ? "This page has 1 child page. Its address will change too"
      : `This page has ${count} child pages. Their addresses will change too`;

  return (
    <p className={styles.moveWarning}>
      {summary}, e.g. {sectionPath(oldSection, example.slug)} to{" "}
      {sectionPath(newSection, movedPath(example.slug, oldPath, newPath))}.
    </p>
  );
}
